import { useContext, useRef } from 'react';
import ArrowLeft from '../../../assets/icons/ArrowLeft';
import ArrowRight from '../../../assets/icons/ArrowRight';
import Button from '../../../ui/Button';
import FlipCard from '../../../ui/FlipCard';
import Heading from '../../../ui/Heading';
import WhiteCard from '../../../ui/WhiteCard';

import UnclaimedBack from './UnclaimedBack';
import UnclaimedCard from './UnclaimedCard';
import { ProfileContext } from '../../../contexts/ProfileContext';
import NoDataAvailable from '../../../ui/NoDataAvailable';

function AllUnclaimedCards({ askToConnectWallet, setAskToConnectWallet }) {
    const { state } = useContext(ProfileContext);
    const unclaimedIcs = state.filter((ic) => ic.status === 'UNCLAIMED');
    const scrollCards = useRef();
    function scrollR() {
        scrollCards.current.scrollBy({
            left: 334,
            behavior: 'smooth',
        });
    }
    function scrollL() {
        scrollCards.current.scrollBy({
            left: -334,
            behavior: 'smooth',
        });
    }
    return (
        <div>
            <Heading className={`text-textGrayHeading leading-10`} type={'medium'}>
                Unclaimed
            </Heading>
            <div className="relative">
                <div
                    verticalMargin=""
                    ref={scrollCards}
                    className="  flex items-center overflow-x-auto  flex-nowrap   scrollableCards"
                >
                    {unclaimedIcs.length > 0 ? (
                        unclaimedIcs.map((ic) => {
                            return (
                                <FlipCard
                                    key={ic.id + ic.status}
                                    width="w-[182px]"
                                    height="h-[252px]"
                                    fixW="w-[182px]"
                                    certificateId={ic.id}
                                    ic={ic}
                                    setAskToConnectWallet={setAskToConnectWallet}
                                    FrontCard={UnclaimedCard}
                                    BackCard={UnclaimedBack}
                                />
                            );
                        })
                    ) : (
                        <div className="flex w-full items-center justify-center">
                            <NoDataAvailable imgClassName="h-[252px]" marginTop="mt-3" />
                        </div>
                    )}
                </div>

                <Button
                    radius="rounded-full"
                    onClick={scrollL}
                    className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -left-[3.15rem] "
                    variant="tertiary"
                    size="circle"
                >
                    <ArrowLeft fillColor="#606060" />
                </Button>

                <Button
                    radius="rounded-full"
                    onClick={scrollR}
                    className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -right-[3.15rem] "
                    variant="tertiary"
                    size="circle"
                >
                    <ArrowRight fillColor={'#606060'} />
                </Button>
            </div>
        </div>
    );
}

export default AllUnclaimedCards;
